import {
  AppAction,
  Application
} from '../apis/eols-app-link/eols-app-link.constants';
import { AppLinkRedirectErrorMessage } from '../pages/app-link-redirect/app-link-redirect.constants';
import {
  ChatUserRoleDto,
  HMPlatformVectorContentTypeDto,
  PostProcessJobTypeDto
} from '../apis/nhe-ai-chat-service/nhe-ai-chat-service.dtos';
import { Brand } from '../constants/common.constants';
import { QuizPanelMode } from '../components/quiz-questions-panel/quiz-questions-panel.constants';

export enum NewRelicAnalyticsAction {
  LOGIN_LAUNCH = 'LOGIN_LAUNCH',
  APP_LINK_LAUNCH = 'APP_LINK_LAUNCH',
  APP_LINK_ERROR = 'APP_LINK_ERROR',
  APP_LINK_OUT = 'APP_LINK_OUT',
  API_ERROR = 'API_ERROR',
  OSMOSIS_VIDEO_PLAYER_EVENT = 'OSMOSIS_VIDEO_PLAYER_EVENT',
  AI_CHAT_CITATION_CLICK = 'AI_CHAT_CITATION_CLICK',
  AI_CHAT_CITATION_LINK_CLICK = 'AI_CHAT_CITATION_LINK_CLICK',
  AI_CHAT_CITATION_VST_NAVIGATE = 'AI_CHAT_CITATION_VST_NAVIGATE',
  EBOOK_CFI_LINK_RESULT = 'EBOOK_CFI_LINK_RESULT',
  AI_CHAT_EDIT_CLICK = 'AI_CHAT_EDIT_CLICK',
  AI_CHAT_EDIT_CONFIRM_CLICK = 'AI_CHAT_EDIT_CONFIRM_CLICK',
  AI_CHAT_CHAT_CLICK = 'AI_CHAT_CHAT_CLICK',
  AI_CHAT_NEW_CHAT_CLICK = 'AI_CHAT_NEW_CHAT_CLICK',
  AI_CHAT_RETURN_CLICK = 'AI_CHAT_RETURN_CLICK',
  AI_CHAT_CANCEL_FEEDBACK_CLICK = 'AI_CHAT_CANCEL_FEEDBACK_CLICK',
  AI_CHAT_FEEDBACK_DIMENSION_CLICK = 'AI_CHAT_FEEDBACK_DIMENSION_CLICK',
  AI_CHAT_FEEDBACK_FACE_CLICK = 'AI_CHAT_FEEDBACK_FACE_CLICK',
  AI_CHAT_FEEDBACK_SUBMIT = 'AI_CHAT_FEEDBACK_SUBMIT',
  AI_CHAT_COPY_CLICK = 'AI_CHAT_COPY_CLICK',
  AI_CHAT_VIDEO_LINK_CLICK = 'AI_CHAT_VIDEO_LINK_CLICK',
  AI_CHAT_SIDEBAR_FEEDBACK_LINK_CLICK = 'AI_CHAT_SIDEBAR_FEEDBACK_LINK_CLICK',
  AI_CHAT_HOW_IT_WORKS_LINK_CLICK = 'AI_CHAT_HOW_IT_WORKS_LINK_CLICK',
  AI_CHAT_PROMPT_SUBMITTED = 'AI_CHAT_PROMPT_SUBMITTED',
  AI_CHAT_ERROR = 'AI_CHAT_ERROR',
  AI_CHAT_CITATION_EXPAND_TOGGLE = 'AI_CHAT_CITATION_EXPAND_TOGGLE',
  AI_CHAT_BOT_RESPONSE_COMPLETE = 'AI_CHAT_BOT_RESPONSE_COMPLETE',
  AI_CHAT_ACTION_WHILE_STREAMING_ERROR = 'AI_CHAT_ACTION_WHILE_STREAMING_ERROR',
  AI_CHAT_TOP_NAV_CLICK = 'AI_CHAT_TOP_NAV_CLICK',
  AI_CHAT_STUDENT_THEMES_CLICK = 'AI_CHAT_STUDENT_THEMES_CLICK',
  AI_CHAT_STUDENT_THEMES_RESULTS = 'AI_CHAT_STUDENT_THEMES_RESULTS',
  AI_CHAT_FOLLOW_UP_QUERY_SUBMIT = 'AI_CHAT_FOLLOW_UP_QUERY_SUBMIT',
  AI_CHAT_LOAD_MORE_ENTRIES_CLICK = 'AI_CHAT_LOAD_MORE_ENTRIES_CLICK',
  AI_CHAT_RELATED_CONTENT_CLICK = 'AI_CHAT_RELATED_CONTENT_CLICK',
  AI_CHAT_RELATED_CONTENT_EXPAND_TOGGLE = 'AI_CHAT_RELATED_CONTENT_EXPAND_TOGGLE',
  AI_CHAT_REFERENCE_CLICK = 'AI_CHAT_REFERENCE_CLICK',
  AI_CHAT_RELATED_CONTENT_SOURCE_LINK_CLICK = 'AI_CHAT_RELATED_CONTENT_SOURCE_LINK_CLICK',
  AI_CHAT_FLASHCARD_VIEW_CLICK = 'AI_CHAT_FLASHCARD_VIEW_CLICK',
  AI_CHAT_FLASHCARD_PLAYER_CLICK = 'AI_CHAT_FLASHCARD_PLAYER_CLICK',
  AI_CHAT_FLASHCARD_COPY_CLICK = 'AI_CHAT_FLASHCARD_COPY_CLICK',
  AI_CHAT_QUIZ_COPY_CLICK = 'AI_CHAT_QUIZ_COPY_CLICK',
  AI_CHAT_QUIZ_QUESTION_VIEW_CLICK = 'AI_CHAT_QUIZ_QUESTION_VIEW_CLICK',
  AI_CHAT_QUIZ_VIEW_ALL_EXPAND_CLICK = 'AI_CHAT_QUIZ_VIEW_ALL_EXPAND_CLICK',
  AI_CHAT_QUIZ_TAKE_OPEN = 'AI_CHAT_QUIZ_TAKE_OPEN',
  AI_CHAT_QUIZ_TAKE_READY = 'AI_CHAT_QUIZ_TAKE_READY',
  AI_CHAT_QUIZ_TAKE_ERROR = 'AI_CHAT_QUIZ_TAKE_ERROR',
  AI_CHAT_POST_PROCESS_JOB_FAILED = 'AI_CHAT_POST_PROCESS_JOB_FAILED',
  JS_ERROR = 'JS_ERROR',
  JS_ERROR_PAGE_REFRESH = 'JS_ERROR_PAGE_REFRESH',
  AI_CHAT_LAUNCH_REDIRECTED = 'AI_CHAT_LAUNCH_REDIRECTED',
  BOOK_FILTER_BTN_CLICK = 'BOOK_FILTER_BTN_CLICK',
  TOKEN_401_AUTHORIZATION_ERROR = 'TOKEN_401_AUTHORIZATION_ERROR',
  WELCOME_DISCLAIMER_ACCEPTED = 'WELCOME_DISCLAIMER_ACCEPTED',
  TOKEN_FORCE_REFRESH_TRIGGERED = 'TOKEN_FORCE_REFRESH_TRIGGERED',
  TOKEN_FORCE_REFRESH_SUCCESS = 'TOKEN_FORCE_REFRESH_SUCCESS',
  TOKEN_FORCE_REFRESH_FAILED = 'TOKEN_FORCE_REFRESH_FAILED',
  REFRESH_TOKEN_ROTATION_SUCCESS = 'REFRESH_TOKEN_ROTATION_SUCCESS',
  REFRESH_TOKEN_ROTATION_FAILED = 'REFRESH_TOKEN_ROTATION_FAILED',
  IDLE_SESSION_TIMEOUT_NO_REFRESH_TOKEN = 'IDLE_SESSION_TIMEOUT_NO_REFRESH_TOKEN',
}

/**
 * Where a TAKE-mode quiz was launched from, so Quiz Questions page takes can be
 * monitored separately from in-chat takes.
 */
export enum QuizTakeSource {
  CHAT = 'chat',
  QUIZ_QUESTIONS_PAGE = 'quiz-questions-page',
}

/**
 * Which leg of the TAKE-mode setup chain failed. The two API calls fail in
 * ways that look identical to the user, so the stage has to be recorded
 * explicitly to tell them apart in New Relic.
 */
export enum QuizTakeFailureStage {
  FETCH_QUESTIONS = 'FETCH_QUESTIONS',
  CREATE_PRACTICE_QUIZ = 'CREATE_PRACTICE_QUIZ',
  MISSING_ASSESSMENT_ID = 'MISSING_ASSESSMENT_ID',
  APP_LINK_OUT = 'APP_LINK_OUT',
}

export enum PostProcessJobBailOutReason {
  LOOKUP_HTTP_ERROR = 'LOOKUP_HTTP_ERROR',
  POLL_BY_ID_HTTP_ERROR = 'POLL_BY_ID_HTTP_ERROR',
  NOT_FOUND_CAP = 'NOT_FOUND_CAP',
}

export type AnalyticsActionProps = {
  action: NewRelicAnalyticsAction.LOGIN_LAUNCH;
  props: null;
} | {
  action: NewRelicAnalyticsAction.API_ERROR;
  props: {
    status: string;
    action: string;
    url: string;
    method: string;
  };
} | {
  action: NewRelicAnalyticsAction.APP_LINK_ERROR;
  props: {
    type: AppLinkRedirectErrorMessage;
    status: string;
    url: string;
    method: string;
  };
} | {
  action: NewRelicAnalyticsAction.APP_LINK_OUT
    | NewRelicAnalyticsAction.APP_LINK_LAUNCH;
  props: {
    linkType: AppAction;
    srcApp: Application;
    targetApp: Application;
  };
} | {
  action: NewRelicAnalyticsAction.OSMOSIS_VIDEO_PLAYER_EVENT;
  props: {
    type: string;
    activeChatId: string;
    videoId: string;
  };
}| {
  action: NewRelicAnalyticsAction.AI_CHAT_CITATION_CLICK;
  props: {
    type: string;
    resourceType: string;
    citationId: number;
    entryId: number;
  };
} | {
  action: NewRelicAnalyticsAction.AI_CHAT_CITATION_LINK_CLICK;
  props: {
    type: string;
    resourceType: string;
    citationId: number;
    entryId: number;
    pageStart: number;
    eeoISBN: string;
    isNotLinked: boolean;
    contentType: HMPlatformVectorContentTypeDto;
  };
} | {
  action: NewRelicAnalyticsAction.AI_CHAT_CITATION_VST_NAVIGATE;
  props: {
    isbn: string;
    startPage: number;
    endPage: number;
    chunkId: string;
    breadcrumbTitles: string[];
    citationId: number;
    entryId: number;
  };
} | {
  action: NewRelicAnalyticsAction.EBOOK_CFI_LINK_RESULT;
  props: {
    isbn: string;
    cfiRange: string;
    // 'no_content' means VitalSource confirmed no content for this CFI, so the
    // page-range endpoint is used as a fallback. Outright failures are covered
    // by the generic API_ERROR event.
    status: 'success' | 'no_content';
  };
} | {
  action: NewRelicAnalyticsAction.AI_CHAT_EDIT_CLICK;
  props: {
    targetChatId: number;
    targetChatTitle: string;
    isTargetActive: boolean;
  };
} | {
  action: NewRelicAnalyticsAction.AI_CHAT_CHAT_CLICK
    | NewRelicAnalyticsAction.AI_CHAT_EDIT_CONFIRM_CLICK;
  props: {
    targetChatId: number;
    targetChatTitle: string;
    isTargetActive: boolean;
    isStreaming: boolean;
    chatUserRole: ChatUserRoleDto;
  };
} | {
  action: NewRelicAnalyticsAction.AI_CHAT_RETURN_CLICK
    | NewRelicAnalyticsAction.AI_CHAT_CANCEL_FEEDBACK_CLICK;
  props: null;
} | {
  action: NewRelicAnalyticsAction.AI_CHAT_NEW_CHAT_CLICK;
  props: {
    isStreaming: boolean;
    chatUserRole: ChatUserRoleDto;
  };
} | {
  action: NewRelicAnalyticsAction.AI_CHAT_FEEDBACK_FACE_CLICK;
  props: {
    rating: number;
    entryId: number;
  };
} | {
  action: NewRelicAnalyticsAction.AI_CHAT_FEEDBACK_SUBMIT;
  props: {
    rating: number;
    entryId: number;
    isFaceClick: boolean;
    chatUserRole: ChatUserRoleDto;
  };
} | {
  action: NewRelicAnalyticsAction.AI_CHAT_FEEDBACK_DIMENSION_CLICK;
  props: {
    rating: number;
    name: string;
    isActiveWhenClicked: boolean;
    entryId: number;
    chatUserRole: ChatUserRoleDto;
  };
} | {
  action: NewRelicAnalyticsAction.AI_CHAT_COPY_CLICK;
  props: {
    entryId: number;
    idx: number;
  };
} | {
  action: NewRelicAnalyticsAction.AI_CHAT_PROMPT_SUBMITTED;
  props: {
    entryId: number;
    idx: number;
    isFollowUpQuestion: boolean;
    isAppLinkQuery: boolean;
    isPromptExample: boolean;
    selectedIsbn: string;
    chatUserRole: ChatUserRoleDto;
  };
} | {
  action: NewRelicAnalyticsAction.AI_CHAT_VIDEO_LINK_CLICK;
  props: {
    entryId: number;
    recommendationId: number;
    videoId: string;
  };
} | {
  action: NewRelicAnalyticsAction.AI_CHAT_SIDEBAR_FEEDBACK_LINK_CLICK
    | NewRelicAnalyticsAction.AI_CHAT_HOW_IT_WORKS_LINK_CLICK;
  props: null;
} | {
  action: NewRelicAnalyticsAction.AI_CHAT_ERROR;
  props: {
    type: string;
    entryId: number;
    chatId: number;
  };
} | {
  action: NewRelicAnalyticsAction.AI_CHAT_CITATION_EXPAND_TOGGLE;
  props: {
    statusAfterToggle: string;
  };
} | {
  action: NewRelicAnalyticsAction.AI_CHAT_BOT_RESPONSE_COMPLETE;
  props: {
    millisecondsToComplete: number;
    millisecondsToCompleteTotal: number;
    millisecondsToFirstToken: number;
    entryId: number;
    idx: number;
    isError: boolean;
    chatUserRole: ChatUserRoleDto;
  };
} | {
  action: NewRelicAnalyticsAction.AI_CHAT_ACTION_WHILE_STREAMING_ERROR;
  props: {
    actionRef: string;
  };
} | {
  action: NewRelicAnalyticsAction.AI_CHAT_TOP_NAV_CLICK;
  props: {
    targetPage: string;
  };
} | {
  action: NewRelicAnalyticsAction.JS_ERROR;
  props: {
    errorName: string;
    errorMessage: string;
    errorStack: string;
  };
} | {
  action: NewRelicAnalyticsAction.AI_CHAT_STUDENT_THEMES_CLICK;
  props: {
    isRetry: boolean;
  };
} | {
  action: NewRelicAnalyticsAction.AI_CHAT_STUDENT_THEMES_RESULTS;
  props: {
    requestHash: string;
    size: number;
  };
} | {
  action: NewRelicAnalyticsAction.AI_CHAT_FOLLOW_UP_QUERY_SUBMIT;
  props: {
    entryId: number;
    idx: number;
    chatUserRole: ChatUserRoleDto;
  };
} | {
  action: NewRelicAnalyticsAction.AI_CHAT_LOAD_MORE_ENTRIES_CLICK;
  props: {
    nextPage: number;
    activeChatId: number;
  };
} | {
  action: NewRelicAnalyticsAction.AI_CHAT_RELATED_CONTENT_CLICK;
  props: {
    contentType: string;
    relatedContentId: number;
    entryId: number;
  };
} | {
  action: NewRelicAnalyticsAction.AI_CHAT_RELATED_CONTENT_EXPAND_TOGGLE;
  props: {
    statusAfterToggle: string;
  };
} | {
  action: NewRelicAnalyticsAction.AI_CHAT_REFERENCE_CLICK;
  props: {
    type: string;
    resourceType: string;
    referenceId: number;
    entryId: number;
  };
} | {
  action: NewRelicAnalyticsAction.AI_CHAT_RELATED_CONTENT_SOURCE_LINK_CLICK;
  props: {
    relatedContentId: number;
    isbn: string;
    page: number;
    contentType: string;
    entryId: number;
  };
} | {
  action: NewRelicAnalyticsAction.AI_CHAT_LAUNCH_REDIRECTED;
  props: {
    ref: string;
  };
} | {
  action: NewRelicAnalyticsAction.JS_ERROR_PAGE_REFRESH;
  props: null;
}| {
  action: NewRelicAnalyticsAction.BOOK_FILTER_BTN_CLICK;
  props: {
    btn: string;
    selectedIsbn: string;
  };
}| {
  action: NewRelicAnalyticsAction.AI_CHAT_FLASHCARD_VIEW_CLICK;
  props: {
    entryId: number;
    chatUserRole: ChatUserRoleDto;
  };
}| {
  action: NewRelicAnalyticsAction.AI_CHAT_QUIZ_QUESTION_VIEW_CLICK;
  props: {
    entryId: number;
    chatUserRole: ChatUserRoleDto;
    mode?: QuizPanelMode;
  };
}| {
  action: NewRelicAnalyticsAction.AI_CHAT_QUIZ_VIEW_ALL_EXPAND_CLICK;
  props: {
    chatUserRole: ChatUserRoleDto;
  };
}| {
  action: NewRelicAnalyticsAction.AI_CHAT_POST_PROCESS_JOB_FAILED;
  props: {
    jobType: PostProcessJobTypeDto;
    entryId: number;
    chatId: number;
    reason: PostProcessJobBailOutReason;
    jobId?: number;
    attemptCount: number;
  };
}| {
  action: NewRelicAnalyticsAction.AI_CHAT_FLASHCARD_PLAYER_CLICK;
  props: {
    btnName: string;
    chatUserRole: ChatUserRoleDto;
  };
}| {
  action: NewRelicAnalyticsAction.AI_CHAT_FLASHCARD_COPY_CLICK;
  props: {
    chatUserRole: ChatUserRoleDto;
  };
}| {
  action: NewRelicAnalyticsAction.AI_CHAT_QUIZ_TAKE_OPEN;
  props: {
    entryId: number;
    source: QuizTakeSource;
    chatUserRole: ChatUserRoleDto;
  };
}| {
  action: NewRelicAnalyticsAction.AI_CHAT_QUIZ_TAKE_READY;
  props: {
    entryId: number;
    source: QuizTakeSource;
    chatUserRole: ChatUserRoleDto;
    assessmentId: number;
    questionCount: number;
    durationMs: number;
  };
}| {
  action: NewRelicAnalyticsAction.AI_CHAT_QUIZ_TAKE_ERROR;
  props: {
    entryId: number;
    source: QuizTakeSource;
    chatUserRole: ChatUserRoleDto;
    stage: QuizTakeFailureStage;
    errorMessage: string;
    durationMs: number;
    status?: string;
    assessmentId?: number;
    questionCount?: number;
  };
}| {
  action: NewRelicAnalyticsAction.AI_CHAT_QUIZ_COPY_CLICK;
  props: {
    chatUserRole: ChatUserRoleDto;
  };
}| {
  action: NewRelicAnalyticsAction.TOKEN_401_AUTHORIZATION_ERROR;
  props: {
    url: string;
    method: string;
    isRegistered: boolean;
    isValid: boolean;
    hasScheduledRefresh: boolean;
    timeToRefreshSeconds: number;
    timeToExpirationSeconds: number;
    isExpired: boolean;
  };
}| {
  action: NewRelicAnalyticsAction.WELCOME_DISCLAIMER_ACCEPTED;
  props: {
    brand: Brand;
    version: number;
  };
}| {
  action: NewRelicAnalyticsAction.TOKEN_FORCE_REFRESH_TRIGGERED;
  props: {
    timeToExpiration: number;
  };
}| {
  action: NewRelicAnalyticsAction.TOKEN_FORCE_REFRESH_SUCCESS
    | NewRelicAnalyticsAction.REFRESH_TOKEN_ROTATION_SUCCESS
    | NewRelicAnalyticsAction.IDLE_SESSION_TIMEOUT_NO_REFRESH_TOKEN;
  props: null;
}| {
  action: NewRelicAnalyticsAction.TOKEN_FORCE_REFRESH_FAILED;
  props: {
    errorMessage: string;
    isRegistered: boolean;
    isValid: boolean;
    hasScheduledRefresh: boolean;
    timeToRefreshSeconds: number;
    timeToExpirationSeconds: number;
    isExpired: boolean;
  };
}| {
  action: NewRelicAnalyticsAction.REFRESH_TOKEN_ROTATION_FAILED;
  props: {
    errorMessage: string;
  };
};
